import { IEnumeration, IEnumeratedSetContract } from 'utility-js-enumeration';
export interface IDeeplinkConfigurationObject {
  page: string;
  state: string;
  pageDescription?: string;
  hybridState: string;
  deepLinkString: string;
  href?: string;
  stateParams: {
    firstParam: string;
    secondParam: string;
    thirdParam: string;
  };
  constructRouteParams: ($stateParams: ng.ui.IStateParamsService) => any | void;
  getState: ($stateParams: ng.ui.IStateParamsService) => string;
  getHref: () => string | undefined;
  constructHybridRouteParams: Function | void;
  getHybridState: Function | void;
  readonly ordinal?: number;
  readonly key?: string;
  readonly id?: string;
  readonly value?: any;
}

export interface IDeeplinkEnumeration extends IEnumeratedSetContract {
  // ONLINE: IDayOfTheWeekValue;
}

export interface IDeeplinkStorageObjects {
  [propName: string]: any;
}

interface IStateObject {
  state: string;
  stateParams: Object;
}

const DEFAULT_LINK: IDeeplinkConfigurationObject = {
  page: 'default',
  state: 'my.feed',
  hybridState: 'my.feed',
  deepLinkString: '',
  stateParams: {
    firstParam: '',
    secondParam: '',
    thirdParam: ''
  },
  constructRouteParams: function (params: any): any {
    return {
      [this.stateParams.firstParam]: params.firstParam,
      [this.stateParams.secondParam]: params.secondParam,
      [this.stateParams.thirdParam]: params.thirdParam
    };
  },
  constructHybridRouteParams: function (params: any): string {
    return params;
  },
  getState: function (params: any): string {
    return this.state;
  },
  getHref: function (): string | undefined {
    return this.href;
  },
  getHybridState: function (params: any): string {
    return this.hybridState;
  }
};

export class DeeplinkConfig implements ng.IServiceProvider {
  public _keys: IDeeplinkStorageObjects = {};
  private _configurations: IDeeplinkStorageObjects = {};
  private _enum: IDeeplinkEnumeration = {} as IDeeplinkEnumeration;
  private _storedState: IStateObject | {};
  private _storedHref: string = '';
  private _trackingProperty: string = 't';
  private _trackingFunction: Function = angular.noop;
  private _defaultState: string = 'my.feed';
  private _originalDeeplink: string = '';

  constructor(private Enumeration: IEnumeration) {}

  set trackingProperty(trackingProp: string) {
    this._trackingProperty = trackingProp;
  }

  registerConfiguration(config: IDeeplinkConfigurationObject): void {
    config = _.merge({}, DEFAULT_LINK, config);
    this._keys[config.page.toUpperCase()] = config.page.toLowerCase();
    this._configurations[config.page] = config;
  }

  registerConfigurationArray(configArray: Array<IDeeplinkConfigurationObject>): void {
    _.forEach(configArray, (config: IDeeplinkConfigurationObject): void => this.registerConfiguration(config));
  }

  storeState(state: any): any {
    this._storedState = state;
  }

  getStoredState(): any {
    return this._storedState;
  }

  storeHref(href: string): any {
    this._storedHref = href;
  }

  getStoredHref(): any {
    return this._storedHref;
  }

  setOriginalDeeplink(url: string) {
    this._originalDeeplink = url;
  }

  getOriginalDeeplink(): string {
    return this._originalDeeplink;
  }

  deleteStoredState(): void {
    this._storedState = {};
  }

  setTrackingFunction(fn: Function): void {
    this._trackingFunction = fn;
  }

  trackLink(...args: any[]): void {
    this._trackingFunction(...args);
  }

  setDefaultState(state: string): void {
    this._defaultState = state;
  }

  hasHybridTrackingInfo(stateParams: IDeeplinkStorageObjects): any {
    return _.result(stateParams, this._trackingProperty);
  }

  hasTrackingInfo(stateParams: IDeeplinkStorageObjects): string {
    const QUERY_CHARACTER_PAD: number = _.size('=');
    const QUERY_STRING_DELIMITER: string = `?${this._trackingProperty}`;
    const trackingParamKey: string = _.findKey(stateParams, (param: any) => param.indexOf(QUERY_STRING_DELIMITER) > -1);

    if (_.isEmpty(trackingParamKey)) {
      return '';
    }

    const trackingString: string = stateParams[trackingParamKey];
    const sliceIndex: number = trackingString.indexOf(QUERY_STRING_DELIMITER);

    stateParams[trackingParamKey] = trackingString.slice(0, sliceIndex);
    return trackingString.slice(sliceIndex + _.size(QUERY_STRING_DELIMITER) + QUERY_CHARACTER_PAD);
  }

  getDefaultState(): string {
    return this._defaultState;
  }

  private createEnum(): void {
    this.Enumeration('Deeplink', this._keys);
    this.Enumeration.useDefinitionAsEnum('Deeplink', this._configurations);
    this._enum = window['enums']['Deeplink'];
  }

  getDeeplinkEnum(): IDeeplinkEnumeration {
    return this._enum;
  }

  $get(): this {
    this.createEnum();
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-deeplink/src/config/deeplink_config.ts